import { claimSlice } from '../claimSlice';

export const { cleanClaim } = claimSlice.actions;
